export default "__VITE_ASSET__CjnJLegR__"